import { Pipe, PipeTransform } from "@angular/core";
import { FormControl } from "@angular/forms";
import { toTitleCase } from "app/constants/messages";

@Pipe({
  name: "validate",
})
export class ValidationErrorPipe implements PipeTransform {
  constructor() {}

  transform(control: FormControl, name: string): any {
    return control && control.errors
      ? this.getValidationError(control, name)
      : "";
  }

  getValidationError(control: FormControl, name) {
    if (control.hasError("required")) {
      return `* ${toTitleCase(name)} is Required`;
    }
    if (control.hasError("pattern")) {
      return `Invalid ${name}`;
    }
    if (control.hasError("minlength")) {
      return `${toTitleCase(name)} must be ${control.errors.minlength.requiredLength} characters long`;
    }
    if (control.hasError("maxlength")) {
      return `${toTitleCase(name)} cannot be more than ${control.errors.maxlength.requiredLength} characters long`;
    }
  }
}
